import React from 'react';
import './InfoWindow.scss';
import Icon from '../../icons';
import { ORDER_STATUSES_DISPLAY, STEP_TYPE, DAYTIME_FORMAT } from '../../constants';
import moment from 'moment';

export const VehicleInfoWindow = ({ item, imageBaseUrl }) => {
  const headerContent = (
    <div className="info-header">
      <Icon type="InfoWindowCar" className="info-icon" color={item.color} />
      <span className="info-id" style={{ color: item.color }}>
        {item?.driver?.name}
      </span>
    </div>
  );

  const startRouteImages = item.fileRoutes?.filter((img) => img.type === 'START_ROUTE').map((fr) => fr.file) || [];
  const endRouteImages = item.fileRoutes?.filter((img) => img.type === 'END_ROUTE').map((fr) => fr.file) || [];

  const infoWindow = (
    <div className="info-window">
      <div className="info-content">
        <div className="info-detail">
          <strong>Driver</strong> <span>{item?.driver?.name}</span>
        </div>
        <div className="info-detail">
          <strong>Phone</strong> <span>{item?.driver?.phone}</span>
        </div>
        <div className="info-detail">
          <strong>Start Address</strong> <span>{item.startAddress}</span>
        </div>
        <div className="info-detail">
          <strong>End Address</strong> <span>{item.endAddress || '-'}</span>
        </div>
        <div className="info-detail">
          <strong>Hub Name</strong> <span>{item.schedulerForm?.fleet?.hub?.name}</span>
        </div>
        <div className="info-detail">
          <strong>Hub Address</strong> <span>{item.schedulerForm?.fleet?.hub?.startAddress}</span>
        </div>
        <div className="info-detail">
          <strong>Fleet name</strong> <span>{item.schedulerForm?.fleet?.name}</span>
        </div>
        <div className="info-detail">
          <strong>Weight</strong> <span>{item.schedulerForm?.fleet?.weight}</span>
        </div>
        <div className="info-detail">
          <strong>Volume</strong> <span>{item.schedulerForm?.fleet?.volume}</span>
        </div>
        <div className="info-detail">
          <strong>Shift Start</strong> <span>{item.shiftStart}</span>
        </div>
        <div className="info-detail">
          <strong>Actual Shift Start</strong>
          <span>{item.actualShiftStart ? moment(item.actualShiftStart).format('H:mm') : ''}</span>
        </div>
        <div className="info-detail">
          <strong>Shift End</strong> <span>{item.shiftEnd}</span>
        </div>
        <div className="info-detail">
          <strong>Dispatched At</strong>{' '}
          <span>{item.dispatchedAt ? moment(item.dispatchedAt).format(DAYTIME_FORMAT) : ''}</span>
        </div>
        <div className="info-detail">
          <strong>Actual Shift End</strong>
          <span>{item.actualShiftEnd ? moment(item.actualShiftEnd).format('H:mm') : ''}</span>
        </div>
        <div className="info-detail">
          <strong>Tag</strong> <span>{item.schedulerForm?.fleet?.tag}</span>
        </div>
        <div className="info-detail">
          <strong>Skills</strong> <span>{item.schedulerForm?.skills?.join(', ')}</span>
        </div>
        <div className="info-detail">
          <strong># of pickups </strong> <span>{item.countPickup}</span>
        </div>
      </div>

      {(startRouteImages.length > 0 || endRouteImages.length > 0) && (
        <div className="info-images">
          {startRouteImages.length > 0 && (
            <div className="image-section">
              <strong>Start Route Images</strong>
              <div className="image-gallery">
                {startRouteImages.map((image) => (
                  <a
                    key={image.id}
                    href={`${imageBaseUrl}${image.key}`}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="route-image-link"
                  >
                    <img src={`${imageBaseUrl}${image.key}`} alt="Start Route" className="route-image" />
                  </a>
                ))}
              </div>
            </div>
          )}

          {/* Hiển thị ảnh END_ROUTE */}
          {endRouteImages.length > 0 && (
            <div className="image-section">
              <strong>End Route Images</strong>
              <div className="image-gallery">
                {endRouteImages.map((image) => (
                  <a
                    key={image.id}
                    href={`${imageBaseUrl}${image.key}`}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="route-image-link"
                  >
                    <img src={`${imageBaseUrl}${image.key}`} alt="End Route" className="route-image" />
                  </a>
                ))}
              </div>
            </div>
          )}
        </div>
      )}
    </div>
  );
  return { headerContent, infoWindow };
};

export const StopInfoWindow = ({ item, items }) => {
  const headerContent = (
    <div className="info-header">
      <Icon type="InfoWindowCar" className="info-icon" />
      <a
        className="info-id"
        style={{ color: item.color }}
        href={`${window.location.origin}/admin/orders/${item.orderCode}`}
        target="_blank"
        rel="noopener noreferrer"
      >
        {item.orderCode}
      </a>
    </div>
  );

  const steps =
    item.type === STEP_TYPE.delivery
      ? items.filter((i) => i.type === STEP_TYPE.pickup && i.orderIds?.includes(item.orderId))
      : items.filter((i) => i.type === STEP_TYPE.delivery && item.orderIds?.includes(i.orderId));

  const infoWindow = (
    <div className="info-window">
      <div className="info-content">
        <div className="info-detail">
          <strong>Location</strong> <span>{item?.address}</span>
        </div>
        <div className="info-detail">
          <strong>Duration</strong> <span>{item?.duration}</span>
        </div>
        <div className="info-detail">
          <strong>{item.type === STEP_TYPE.pickup ? 'Pickup Name' : 'Delivery Name'}</strong> <span>{item?.name}</span>
        </div>
        <div className="info-detail">
          <strong>Arrival Time</strong> <span>{item?.arrivalTime || '-'}</span>
        </div>
        <div className="info-detail">
          <strong>Finish Time</strong> <span>{item?.finishTime || '-'}</span>
        </div>
        <div className="info-detail">
          <strong>Start Time</strong> <span>{item?.startTime}</span>
        </div>
        <div className="info-detail">
          <strong>End Time</strong> <span>{item?.endTime}</span>
        </div>
        <div className="info-detail">
          <strong>Type</strong> <span>{item?.type}</span>
        </div>
        <div className="info-detail">
          <strong>Status</strong> <span>{ORDER_STATUSES_DISPLAY[item?.orderStatus] || item?.orderStatus}</span>
        </div>
        <div className="info-detail">
          <strong>Order Types</strong> <span>{item?.orderTypes?.join(', ')}</span>
        </div>
        <div className="info-detail">
          <strong>Ticket Names</strong> <span>{item?.ticketNames?.join(', ')}</span>
        </div>
        {item?.unscheduledReason && (
          <div className="info-detail">
            <strong>Reason</strong>
            <span style={{ color: 'red' }}>{item?.unscheduledReason}</span>
          </div>
        )}
        <div className="info-detail">
          {item.type === STEP_TYPE.delivery && steps && (
            <>
              {' '}
              <strong>Pickup: </strong>
              <div className="steps">
                <div className="step" onClick={steps?.onClick}>
                  <div className="pickup" style={{ border: `2px solid ${item.color}`, color: item.color }}>
                    {steps?.index}
                  </div>
                  <b>{steps?.name}</b>
                </div>
              </div>
            </>
          )}
          {item.type === STEP_TYPE.pickup && (
            <>
              {' '}
              <strong>Deliveries: </strong>
              <div className="steps">
                {steps.map((step) => (
                  <div className="step" key={`${step.orderId}_${step.type}`} onClick={step?.onClick}>
                    <div className="delivery" style={{ border: `2px solid ${step.color}`, color: step.color }}>
                      {step?.index}
                    </div>
                    <b>{step.name}</b>
                  </div>
                ))}
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );
  return { headerContent, infoWindow };
};
